import { render, staticRenderFns } from "./EducationalResources.vue?vue&type=template&id=34e4f767&"
import script from "./EducationalResources.vue?vue&type=script&lang=js&"
export * from "./EducationalResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports